import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { Button } from "ui/button";
import { StateSite, deleteSite, updateSite } from "lib/actions";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";
import React from "react";
import Modal from "react-modal";
import { ConfirmModalStyles } from "lib/constants";
import { showToast } from "ui/components/common";
import { SideviewContext } from "context/SideviewContext";
import { useSWRConfig } from "swr";
import { getTimezoneFromGoogleMapApi } from "pages/dashboard/customers/service";
import { APIProvider } from "@vis.gl/react-google-maps";
import AddressSearch from "ui/components/address-select";
import { set } from "date-fns";

export default function Form({
  orgId,
  siteId,
  objData,
}: {
  orgId: string;
  siteId: string;
  objData: any;
}) {
  console.log("--->>> orgId = ", orgId, siteId, objData);
  const { user } = useContext(AuthContext);
  interface formDataType {
    [key: string]: FormDataEntryValue;
  }
  const responseBody: formDataType = {};
  const navigate = useNavigate();

  const [responseData, setResponseData] = useState<StateSite>();
  const [btnSubmitDisabled, setBtnSubmitDisabled] = useState(false);
  const [value, setValue] = useState(null);

  // const [addressCity, setAddressCity] = useState('');
  const [addressCity, setAddressCity] = useState(objData.details.city);
  const [addressState, setAddressState] = useState(objData.details.state);
  const [addressZip, setAddressZip] = useState(objData.details.zipcode);
  const [addressValue, setAddressValue] = useState(objData.details.address);
  const [addressTimezone, setAddressTimezone] = useState(objData?.timezone);
  const [addressLatitude, setAddressLatitude] = useState(
    objData?.details?.polygon[0]?.latitude,
  );
  const [addressLongitude, setAddressLongitude] = useState(
    objData?.details?.polygon[0]?.longitude,
  );
  const [removedSiteId, setRemovedSiteId] = useState("");
  const [removeSiteConfirmModalOpen, setRemoveSiteConfirmModalOpen] =
    useState(false);

  const { setOpenPanel } = useContext(SideviewContext);
  const { mutate: globalMutate } = useSWRConfig();

  // useEffect(() => {
  //   if (!value) {
  //     return;
  //   }
  //   geocodeByPlaceId(value.value.place_id)
  //     .then(async (results) => {
  //       console.log(results);
  //       const place = results[0];
  //       const displayCity = place.address_components.filter((f) => {
  //         const hasCity =
  //           f.types.includes("locality") ||
  //           f.types.includes("sublocality") ||
  //           f.types.includes("administrative_area_level_2");
  //         return hasCity;
  //       })[0]?.long_name;
  //       const displayState = place.address_components.filter(
  //         (f) =>
  //           JSON.stringify(f.types) ===
  //           JSON.stringify(["administrative_area_level_1", "political"]),
  //       )[0]?.long_name;
  //       const displayZip = place.address_components.filter(
  //         (f) => JSON.stringify(f.types) === JSON.stringify(["postal_code"]),
  //       )[0]?.long_name;
  //       setAddressCity(displayCity || "");
  //       setAddressState(displayState || "");
  //       setAddressZip(displayZip || "");
  //       setAddressValue(value?.label ? value?.label : "");

  //       const { lat, lng } = await getLatLng(results[0]);
  //       setAddressLatitude(lat);
  //       setAddressLongitude(lng);
  //       console.log("Successfully got latitude and longitude", { lat, lng });

  //       try {
  //         const res = await getTimezoneFromGoogleMapApi(lat, lng);
  //         if (res?.status === 200) {
  //           setAddressTimezone(res?.data?.timeZoneId);
  //         }
  //       } catch (error) {
  //         showToast(1, "Failed to get timezone");
  //         console.error("fail to get timezone", error);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // }, [value]);

  const hanlePlaceSelect = async (p) => {
    let timezone = "";
    try {
      const res = await getTimezoneFromGoogleMapApi(p.latitude, p.longitude);
      if (res?.status === 200) {
        timezone = res?.data?.timeZoneId;
      }
    } catch (error) {
      showToast(1, "Failed to get timezone");
      console.error("fail to get timezone", error);
    }
    setAddressCity(p.city || "");
    setAddressState(p.state || "");
    setAddressZip(p.zip || "");
    setAddressValue(p.address || "");
    setAddressTimezone(timezone);

    setAddressLatitude(p.latitude);
    setAddressLongitude(p.longitude);
  };

  // useEffect(() => {
  //   setAddressValue(objData?.details?.address || "");
  // }, [objData]);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const formData = new FormData(event.currentTarget as HTMLFormElement);
    formData.forEach(
      (value, property: string) => (responseBody[property] = value),
    );
    formData.append("address", addressValue);
    formData.append("latitude", addressLatitude.toString());
    formData.append("longitude", addressLongitude.toString());
    formData.append("city", addressCity);
    formData.append("state", addressState);
    formData.append("zip", addressZip);
    formData.append("timezone", addressTimezone);

    try {
      setBtnSubmitDisabled(true);
      const response = await updateSite(orgId, siteId, formData);
      setBtnSubmitDisabled(false);
      setResponseData(response);
      console.log("---response = ", response);
      if (response.strReturn) {
        const idCreated = response.strReturn;
        globalMutate([
          `/site/tree?withCameraNum=true&withMonitorInfo=true`,
          user.token,
          orgId,
        ]);
        setOpenPanel(false);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function handleRemoveSite(siteId: string) {
    try {
      console.log("handle remove site with siteId = ", siteId);
      const response = await deleteSite(orgId, siteId);
      showToast(0, "The Site has been removed successfully!");
      // navigate(0);
      globalMutate([
        `/site/tree?withCameraNum=true&withMonitorInfo=true`,
        user.token,
        orgId,
      ]);
      setOpenPanel(false);
    } catch (error) {
      console.error(error);
      navigate(`?modal=true&content=${error}`);
    }
  }

  return (
    <APIProvider
      apiKey={"AIzaSyAqk45RIVytV7tiTjTy2UISpHEgSWjl1vg"}
      onLoad={() => console.log("Maps API has loaded.")}
      onError={(e) => console.log("load error", e)}
    >
      <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
        <div className="rounded-md pb-3">
          {/* <h2 className='text-lg font-medium mb-5'>Add sites to their account</h2> */}
          {/* <p className='text-sm font-medium mb-5'>A site is where cameras and NVRs are installed, and alerts are generated.</p> */}

          {/* Site Name */}
          <div className="mb-4">
            <label htmlFor="name" className="mb-2 block text-sm">
              Site Name
            </label>
            <div className="relative mt-2 rounded-md">
              <div className="relative">
                <input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Site Name"
                  defaultValue={objData.name}
                  // value={objData.name}
                  className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                  aria-describedby="name-error"
                />
              </div>
              <div id="name-error" aria-live="polite" aria-atomic="true">
                {responseData?.errors?.name &&
                  responseData.errors.name.map((error: string) => (
                    <p className="mt-2 text-sm text-red-500" key={error}>
                      {error}
                    </p>
                  ))}
              </div>
            </div>
          </div>

          {/* Site Address */}
          <div className="mb-4">
            <label htmlFor="address" className="mb-2 block text-sm">
              Address
            </label>
            <div className="relative mt-2 rounded-md">
              <div className="relative">
                {/* <input
                  id="address"
                  name="address"
                  type="hidden"
                  placeholder="Enter Address"
                  className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                  aria-describedby="address-error"
                  value={addressValue}
                  readOnly
                />
                <div>
                  <GooglePlacesAutocomplete
                    apiKey="AIzaSyAqk45RIVytV7tiTjTy2UISpHEgSWjl1vg"
                    selectProps={{
                      placeholder: "Enter Address",
                      className: "text-sm",
                      onChange: setValue,
                      value,
                      defaultInputValue: objData.details.address,
                    }}
                  />
                </div> */}
                <AddressSearch
                  inputClassName={
                    "rounded-md w-full text-sm pl-3 pr-4 py-2 border border-gray-200 outline-2"
                  }
                  initInputText={objData?.details?.address || ""}
                  onPlaceSelect={hanlePlaceSelect}
                  placeholder="Enter Address"
                />
              </div>
              <div id="address-error" aria-live="polite" aria-atomic="true">
                {responseData?.errors?.address &&
                  responseData.errors.address.map((error: string) => (
                    <p className="mt-2 text-sm text-red-500" key={error}>
                      {error}
                    </p>
                  ))}
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 md:gap-6">
            {/* City */}
            <div className="mb-4">
              <label htmlFor="city" className="mb-2 block text-sm">
                City
              </label>
              <div className="relative mt-2 rounded-md">
                <div className="relative">
                  <input
                    id="city"
                    name="city"
                    type="text"
                    placeholder="Enter City"
                    className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm placeholder:text-gray-500 outline-2"
                    aria-describedby="first-name-error"
                    value={addressCity}
                    onChange={(e) => setAddressCity(e.target.value)}
                  />
                </div>
                <div id="city-error" aria-live="polite" aria-atomic="true">
                  {responseData?.errors?.city &&
                    responseData.errors.city.map((error: string) => (
                      <p className="mt-2 text-sm text-red-500" key={error}>
                        {error}
                      </p>
                    ))}
                </div>
              </div>
            </div>

            {/* State */}
            <div className="mb-4">
              <label htmlFor="state" className="mb-2 block text-sm">
                State
              </label>
              <div className="relative mt-2 rounded-md">
                <div className="relative">
                  <input
                    id="state"
                    name="state"
                    type="text"
                    placeholder="Enter State"
                    className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500 focus-visible:outline-none bg-neutral-100 cursor-not-allowed"
                    aria-describedby="state-error"
                    value={addressState}
                    // defaultValue={objData.details.state}
                    readOnly
                  />
                </div>
                <div id="state-error" aria-live="polite" aria-atomic="true">
                  {responseData?.errors?.state &&
                    responseData.errors.state.map((error: string) => (
                      <p className="mt-2 text-sm text-red-500" key={error}>
                        {error}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 md:gap-6 mb-4">
            {/* Zip */}
            <div>
              <label htmlFor="zip" className="mb-2 block text-sm">
                Zip/Postal Code
              </label>
              <div className="relative mt-2 rounded-md">
                <div className="relative">
                  <input
                    id="zip"
                    name="zip"
                    type="text"
                    placeholder="Enter Zip/Postal Code"
                    className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm placeholder:text-gray-500 outline-2"
                    aria-describedby="zip-error"
                    value={addressZip}
                    onChange={(e) => setAddressZip(e.target.value)}
                  />
                </div>
                <div id="zip-error" aria-live="polite" aria-atomic="true">
                  {responseData?.errors?.zip &&
                    responseData.errors.zip.map((error: string) => (
                      <p className="mt-2 text-sm text-red-500" key={error}>
                        {error}
                      </p>
                    ))}
                </div>
              </div>
            </div>
            <div>
              <label htmlFor="zip" className="mb-2 block text-sm">
                Timezone
              </label>
              <div className="relative mt-2 rounded-md">
                <div className="relative">
                  <input
                    id="timezone"
                    name="timezone"
                    type="text"
                    placeholder="Enter Timezone"
                    className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500 focus-visible:outline-none bg-neutral-100 cursor-not-allowed"
                    aria-describedby="timezone-error"
                    value={addressTimezone}
                    // defaultValue={objData.details.zipcode}
                    readOnly
                  />
                </div>
                <div id="Timezone-error" aria-live="polite" aria-atomic="true">
                  {responseData?.errors?.timezone &&
                    responseData.errors.timezone.map((error: string) => (
                      <p className="mt-2 text-sm text-red-500" key={error}>
                        {error}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>

          <input
            id="latitude"
            name="latitude"
            type="hidden"
            value={addressLatitude}
          />
          <input
            id="longitude"
            name="longitude"
            type="hidden"
            value={addressLongitude}
          />
        </div>
        <div className="flex justify-between">
          <button
            className="flex items-center rounded-2xl bg-white px-[24px] py-[14px] text-base font-semibold text-blue-500 border border-blue-500 transition-colors hover:text-blue-400 hover:border-blue-400 "
            onClick={() => {
              setOpenPanel(false);
            }}
          >
            Close
          </button>
          <div className="flex justify-end gap-4">
            {/* <Link
          to="/dashboard/customers"
          className="flex h-10 items-center rounded-lg bg-gray-100 px-4 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-200"
        >
          Cancel
        </Link> */}

            <Button
              className="bg-white hover:bg-transparent"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                setRemovedSiteId(objData.id);
                setRemoveSiteConfirmModalOpen(true);
              }}
            >
              <span className="text-red-500 hover:text-red-400">Delete</span>
            </Button>
            <Button type="submit" aria-disabled={btnSubmitDisabled}>
              Save
            </Button>
          </div>
        </div>
        {responseData?.message && (
          <div
            className="p-4 mb-4 mt-12 text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 flex items-center space-x-1"
            role="alert"
            aria-live="polite"
            aria-atomic="true"
          >
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
            <p className="text-sm text-red-500">{responseData.message}</p>
          </div>
        )}
        <Modal
          isOpen={removeSiteConfirmModalOpen}
          style={ConfirmModalStyles}
          contentLabel="Example Modal"
        >
          <h1 className="text-xl font-bold">Do you want to delete the site?</h1>
          <div className="text-base mt-4">
            This site and its associated device(s) will be permanently deleted
            from this account.
          </div>

          <div className="float-right mt-6">
            <button
              className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
              onClick={() => {
                setRemoveSiteConfirmModalOpen(false);
              }}
            >
              Cancel
            </button>
            <button
              className="ml-4 rounded-2xl px-6 py-4 bg-red-500 text-sm font-medium text-white transition-colors hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 active:bg-red-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
              onClick={() => {
                setRemoveSiteConfirmModalOpen(false);
                handleRemoveSite(removedSiteId);
              }}
            >
              Delete
            </button>
          </div>
        </Modal>
      </form>
    </APIProvider>
  );
}
